import { Component, Input, OnInit, Output } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { AppointmetReservated } from "src/app/model/appointmet-reservated";
import { IntegratedOrderConf } from "src/app/model/integrated-admission/integrated-order-conf";
import { IntegratedAdmissionService } from "src/app/services/integrated-admission/integrated-admission.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { OnLineValidationService } from "src/app/services/on-line-validation/on-line-validation.service";
import { ReservationService } from "src/app/services/reservation.service";

@Component({
  selector: "app-orientation-appointment-list",
  templateUrl: "./orientation-appointment-list.component.html",
  styleUrls: ["./orientation-appointment-list.component.css"],
})
export class OrientationAppointmentListComponent implements OnInit {
  @Input() medicalAppointmentIds: number[] = [];
  @Input() loadingAction: boolean = false;
  @Output() finalizedWidthAdmission = new EventEmitter();
  @Output() finalizedWidthOutAdmission = new EventEmitter();

  appointments: AppointmetReservated[] = [];
  loading: boolean = true;

  distintcsPlanId: boolean = false;
  requiredValidation: boolean = false;
  requiredCredential: boolean = false;
  requiredSecurityCode: boolean = false;
  requiredPreAuth: boolean = false;

  credential: string = "";
  securityCode: string = "";
  preAuth: string = "";

  conf: IntegratedOrderConf;

  constructor(
    private onLineValidationService: OnLineValidationService,
    private notificationToastService: NotificationToastService,
    private integratedAdmissionService: IntegratedAdmissionService,
    private reservationService: ReservationService
  ) {}

  async ngOnInit() {
    try {
      this.loading = true;

      this.appointments = await this.reservationService.getAppointmetReservated(
        this.medicalAppointmentIds
      );

      this.distintcsPlanId = this.appointments.some((appointment) => {
        return appointment.PlanId !== this.appointments[0].PlanId;
      });

      this.conf =
        await this.integratedAdmissionService.getIntegratedAdmissionOrderConf(
          this.appointments[0].PlanId,
          false
        );
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Turnos");
    } finally {
      this.loading = false;
    }
  }

  async nextValidate() {
    try {
      this.loadingAction = true;

      await this.onLineValidationService.executeOnLineOperationFromAppointments(
        this.appointments.map((x) => x.Id),
        this.credential,
        this.securityCode,
        this.preAuth
      );
      this.notificationToastService.success(
        "Se validaron los turnos correctamente",
        "Validación"
      );
      this.finalizedWidthAdmission.emit();
    } catch (err) {
      this.notificationToastService.error(
        "Lo datos ingresados son incorrectos",
        "Validación"
      );
    } finally {
      this.loadingAction = false;
    }
  }

  async nextRequiredAsisst() {
    this.finalizedWidthOutAdmission.emit();
  }

  next() {
    if (!this.requiredValidation && this.conf && this.conf.RequiredValidation) {
      this.requiredCredential = this.conf.RequiredCredential;
      this.requiredSecurityCode = this.conf.RequiredSecurityCode;
      this.requiredPreAuth = this.conf.RequiredPreAuth;
      this.requiredValidation = true;
    } else {
      this.finalizedWidthAdmission.emit();
    }
  }
}
